/**
 * All login events here
 */
export const EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  CONTINUE_GUEST: 'continue_as_guest',
  MOBILE_NUMBER_ADD: 'mobile_number_add',
  MOBILE_ERROR: 'mobile_error',
  OTP_SENT: 'otp_sent',
  RESEND_OTP: 'resend_otp',
  LOGIN_WITH_EMAIL: 'login_with_email',
  LOGIN_EMAIL_ERROR: 'login_email_error',
  TEMP_PASSWORD_SEND: 'temp_password_sent',
  CREATE_PASSWORD: 'create_password',
  PASSWORD_UPDATE: 'password_update',
  VERIFY_OTP_ERROR: 'verify_otp_error',
  VERIFY_OTP_SUCCESS: 'verify_otp_success',
  RESET_PASSWORD: 'reset_password',
  RESET_PASSWORD_LINK: 'reset_password_link',
  FORGOT_PASSWORD: 'forgot_password',
  RESET_PASSWORD_ERROR: 'reset_password_error',
  PASSWORD_ERROR: 'password_error',
  BASIC_REGISTRATION_INITIATION: 'basic_registration_initiation',
  BASIC_REGISTRATION_SUCCESS: 'basic_registration_success',
  BASIC_REGISTRATION_FAIL: 'basic_registration_fail',
  VERIFICATION_ATTEMPT_LIMIT_REACHED: 'verification_attempt_limit_reached',
  LOGIN_SUCCESS: 'login_success',
  COMPLETE_PROFILE_INITIATION: 'complete_profile_initiation',
  COMPLETE_PROFILE_SUCCESS: 'complete_profile_successful',
  UAE_PASS_BUTTON_CLICK: 'uae_pass_button_click',
  PROFILE_LINKING_SELECTION: 'profile_linking_selection',
  PROFILE_LINKING_SUCCESS: 'profile_linking_success',
  PROFILE_LINKING_FAIL: 'profile_linking_fail',
  NAVIGATION_BUTTON_CLICK: 'navigation_button_click',
  LOGIN_FAIL: 'login_fail',
  HELP_CENTER_CLICK: 'help_center_click',
  COUNTRY_SELECTION: 'country_selection',
};

export const MY_ASTER_CATEGORY = {
  ASCO: 'asco',
  DOCTOR_CONSULT: 'doctor consult',
  AE: 'epharmacy',
  HC: 'homecare',
};

export const SECTION_NAME ={
  PACKAGE: 'Health Packages'
};

export const PAGE_TYPE = {
  LOGIN: 'login page',
  SETTINGS: 'settings page',
  PROFILE: 'profile page',
  DDP: 'doctor details page',
  HOME: 'homepage',
  RECORDS_PAGE: 'records page',
  RX_HD_PAGE : 'rx home-delivery page',
  POST_CONSULTATION_PAGE: 'post consultation page',
  CLINIC_LISTING_PAGE: 'clinics listing page',
  PROFILE_LINKING_PAGE: 'profile linking page',
  AUTO_REGISTRATION: 'auto registration page'
};

export const SCREEN_NAME = {
  LOGIN: 'login page',
  LOGIN_REGISTER: 'login or register',
  LOGIN_EMAIL: 'login with email',
  ENTER_PASSWORD: 'enter password',
  CREATE_PASSWORD: 'create password',
  RESET_PASSWORD: 'reset password',
  MAIN_SETTINGS: 'main settings',
  RESET_PASSWORD_LINK: 'reset password link',
  FORGOT_PASSWORD: 'forgot password',
  ENTER_TEMP_PASSWORD: 'enter temp password',
  BASIC_REGISTRATION: 'basic registration',
  OTP_SENT: 'otp screen',
  MANY_ATTEMPTS: 'too many attempts',
  MANY_ATTEMPTS_SCREEN: "too many attempts screen",
  RESET_PASSWORD_LINK_EXPIRED: 'reset password link expired',
  RECORDS_PRESCRIPTION: 'records prescription',
  RX_HD_ORDER_CONFIRMATION: 'rx home-delivery order confirmation',
  RX_HD_ADDRESS_DETAILS : 'rx home-delivery address details',
  RX_HD_LOGIN : 'rx home-delivery login',
  RX_HD_OTP: 'rx home-delivery otp',
  POST_CONSULTATION: 'post consultation',
  RX_HD_PRESCRIPTION: 'rx home-delivery prescriptions',
  ORDER_CONFIRMATION: 'package order confirmation',
  SEARCH_RESULT: 'doctor search result',
  MY_PACKAGE_DETAILS: 'my package details',
  PACKAGE_CLINIC_DETAIL: 'package clinics detail',
  PACKAGE_CHECKOUT: 'package checkout',
  INSTANTGP_CHECKOUT: 'instantgp checkout',
  PAYMENT_FAILURE: 'package payment failure',
  PACKAGE_DETAILS: 'package details',
  PACKAGE_ORDER_CONFIRMATION: 'package order confirmation',
  CATEGORY_LISTING: 'category listing',
  CART_EPHARMACY: 'my cart',
  CHECKOUT_EPHARMACY: 'checkout',
  GUEST_CHECKOUT_EPHARMACY: 'guest checkout',
  SEARCH_LANDING_PAGE: 'pharma search result',
  PAYMENT_SUCCESS: 'order confirmation',
  ORDER_DETAILS: 'orders detail',
  RX_UPLOAD: 'rx upload',
  UAE_PASS_PROFILE_LINKING: 'uae pass profile linking',
  UAE_PASS_MANUAL_LINKING: 'uae pass manual profile linking', 
  REFERRAL_LANDING: 'main referrals',
  MY_REFERRALS: 'my referrals listing',
  MY_ORDERS: 'my orders',
  INSTORE_ORDER: 'orders instore',
  LAB_RESULTS: 'lab results',
  RECORDS_DETAILS: 'records detail',
  AE: "epharmacy",
  AL: 'appointments listing',
  AUTO_REGISTRATION: 'auto registration',
  PHARMA_SEARCH_RESULTS: 'pharma search result',
  BRAND_LISTING: 'brand listing page',
  CANCEL_POLICY: 'cancel policy',
  CANCEL_CONFIRM: 'cancellation confirmation',
  BRAND_LISTING: 'brand listing',
  AE_HOME: 'epharmacy homepage',
  DC_HOME: 'doctor consult homepage',
  HC_HOME: 'homcare homepage',
  ASCO_HOME: 'asco homepage',
  AE_PAYMENT_FAIL: 'payment failed',
  AE_ORDER_PROGRESS: 'order animation',
  AE_HEALTH_CONDITION: 'health condition listing',
  AE_LANDING_PAGE: 'pharmacy landing page',
  RETURN_STATUS: 'return status',
  RETURN_CONFIRMATION: 'return confirmation',
  RETURN_POLICY: 'return policy',
  PRODUCT_REVIEW: 'product review',
  SPECIALITY_LIST: 'speciality list',
  CLINIC_LIST: 'clinic list',
  WAITING_ROOM: 'waiting room',
  AP_VIDEO_CALL: 'appointment video call',
  AP_CHECKOUT: 'appointment checkout',
  CHECKOUT_VALIDATION: 'checkout validation',
  BOOKING_CONFIM: 'booking confirmation',
  COMPLETE_PROFILE: 'complete profile',
  DDP_DETAILS: 'doctor details',
  WAITING_CONSENT: 'waitingroom consent',
  AP_UPCOMING_DETAILS: 'upcoming appointment details',
  AP_UPCOMING_LIST: 'upcoming appointment list',
  DOCTOR_LISING: 'doctor listing',
  FACILITY_DETAILS: 'facility details',
  FEEDBACK_DETAILS: 'feedback details',
  INSTANTGP_INFORMATION: 'instantgp information',
  MY_DOCTOR: 'my doctors list',
  PACKAGE_LISTING: 'package listing',
  ORDER_PAYMENT_FAIL: 'order payment fail',
  HC_AP_DETAILS: 'homecare appointment details',
  HC_CHECKOUT: 'homecare checkout',
  HC_CONFIRMATION: 'homecare confirmation',
  HC_FEEDBACK: 'homecare feedback',
  HC_CART: 'homecare my cart',
  HC_CART_AP: 'homecare cart appointment',
  HC_SERVICE: 'homecare service listing',
  HC_DETAILS: 'homecare service details',
  PROFILE_SECURE: 'aster secure',
  CONTENT_ABOUT: 'about us',
  CONTENT_CONSENT: 'consent form',
  CONTENT_PRIVACY: 'privacy policy',
  CONTENT_TERMS: 'terms and conditions',
  COTNENT_FAQ: 'faq',
  DC_INSURANCE: 'insurance',
  DC_WISHLIST: 'wishlist',
  DC_MANAGE_ADD: 'manage address',
  DC_MANAGE_PAYMENT: 'manage payment',
  MY_PACKAGE_LISTING: 'my packages listing',
  DC_MY_SHOPPING: 'my shopping list',
  DC_NOTIFICATION: 'notifications',
  DC_PATIENT_PORTAL: 'patient portal',
  DC_MY_PROFILE: 'my profile',
  DC_MANAGE_FAMILY: 'manage family members',
  DC_MANAGE_FAMILY_DETAIL: 'manage family members details',
  DC_EDIT_PROFILE: 'edit profile',
  AE_PROMOTION: 'promotion leaflet',
  DC_EMAIL_VERIFY: 'email verify',
  UAE_PASS_LOGIN_NAV: 'uae pass login navigation',
  UAE_PASS_LANDING: 'uae pass landing',
  MARKETING_PAGE: 'marketing page',
};

export const PAGE_NAME = {
  DDP: 'doctor details page',
  AE: 'homepage',
  PDP: 'package details page',
  MY_CART: 'my cart page',
  EPHARMA_HOME: 'epharmacy homepage page',
  TC_HOME: 'doctor consult home page',
  HOME: 'asco homepage',
  FDP: 'facility details page',
  FLP: 'facility listing page',
  DLP: 'doctor listing page',
  SRP: 'search results page',
  AP: 'appointments page',
  CP: 'checkout page',
  ADP: 'appointment detail page',
  ALP: 'appointment listing page',
  PROFILE: 'profile page',
  CONTENT: 'content page',
  INSTANTGP: 'instantgp page',
  PACKAGE: 'package page',
  CDP: 'clinics details page',
  ASCO: 'homepage',
  BCP: 'booking confirmation page',
  LP: 'landing page',
  WISHLIST: 'wishlist page',
  RECORDS: 'records page',
  POST_CONSULTATION_PAGE: 'post consultation page',
  BRAND_LISTING: 'brand listing page',
  CATEGORY_LISTING: 'category listing page',
  PLP: 'product listing page',
  PDP_AE: 'product details page',
  CART_EPHARMACY: 'cart page',
  CHECKOUT_EPHARMACY: 'checkout page',
  GUEST_CHECKOUT_EPHARMACY: 'guest checkout page',
  DEALS_PAGE: 'landing page',
  SEARCH_LANDING_PAGE: 'search result page',
  PAYMENT_SUCCESS: 'checkout page',
  ORDER_DETAILS: 'order detail page',
  RX_UPLOAD: 'rx page',
  REFERRAL_LANDING: 'main referrals page',
  MY_REFERRALS: 'my referrals listing page',
  MY_ORDERS: 'order listing page',
  WAITING_ROOM: 'waiting room page',
  RLP: 'records listing page',
  ORDER_PROGRESS: 'order animation page',
  AE_HEALTH_CONDITON_LISTING: 'health condition listing page',
  SPECIALITY_LIST: 'speciality listing page',
  CLINIC_LIST: 'clinic listing page',
  CHECKOUT_VALIDATION: 'checkout validation page',
  COMPLETE_PROFILE: 'complete profile page',
  WAITING_CONSENT: 'waitingroom consent page',
  FEEDBACK_DETAILS: 'feedback details page',
  INSTANTGP_CHECKOUT: 'instantgp checkout page',
  MY_DOCTOR: 'my doctors listing page',
  ORDER_PAYMENT_FAIL: 'order payment fail page',
  HC_CONFIRMATION: 'confirmation page',
  HC_FEEDBACK: 'homecare feedback page',
  HC_SERVICE: 'homecare service Listing page',
  HC_DETAILS: 'homecare service details page',
  DC_LAB: 'lab result page',
  DC_MY_SHOPPING: 'my shopping list page',
  AE_PROMOTION: 'promotion leaflet page',
  DC_EMAIL_VERIFY: 'email verify page',
  UAE_PASS_LOGIN_NAV: 'uae pass login navigation page',
  UAE_PASS_LANDING: 'uae pass landing page'
};

export const PAGE = {
  HOME: "HOME",
  PHARMACY: "PHARMACY",
  PDP: "PDP",
  PLP: "PLP",
  CART: "CART",
  CHECKOUT: "CHECKOUT",
  ORDER_DETAILS: "ORDER_DETAILS",
  ORDER_SUCCESS: "ORDER_SUCCESS",
  ORDER_LISTING: "ORDER_LISTING",
  LANDING_PAGE: "LANDING_PAGE",
  SPCHECKOUT: "CHECKOUT",
  SEARCHRESULT: "PLP",
  BRAND: "PLP", 
  BRANDLISTING: "PLP", 
  LOGIN: "LOGIN",
  SETTINGS: "SETTINGS",
  PROFILE: "PROFILE",
};

export const TYPE = {
  NEW: 'new',
  UPDATING: 'updating',
  EXISTING: 'existing',
  TEMPORARY: 'temporary',
  RESET: 'reset',
  EMAIL: 'email',
  MOBILE: 'mobile number',
  PACKAGE: 'health packages',
  UAE_PASS: 'UAE Pass',
  TEMP_PASSWORD: 'temp password',
  OTP: 'otp',
  FORGET_PASSWORD: 'forgot password',
};

export const PACKAGE_TYPE = {
  MYASTER_EXCLUSIVE: 'myAster Exclusive',
  CLINIC_PACKAGE: 'clinic package',
  HOME_SAMPLE: 'home sample collection package',
};

export const BANNER_NAME = {
  TOP: 'top banner',
  MIDDLE: 'middle banner',
  BOTTOM: 'bottom banner',
  TWO_IN_ONE: '2in1 banner',
};

export const BANNER_PAGE_SLOT = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom',
};

export const PAYMENT_STATUS = {
  SUCCESS: 'successful',
  FAILURE: 'failure',
};

export const ERROR_TYPE = {
  VALIDATION_ERROR: 'validation',
  API_ERROR: 'api',
  NETWORK_ERROR: 'network',
  TIME_OUT_ERROR: 'timeout'
};

export const getPageName = (prevPath) => {
  let refererPage = '';
  if (prevPath?.includes('/doctor-consultation/d/')) {
    refererPage = PAGE_NAME.DDP;
  } else if (prevPath?.includes('/doctor-consultation/packages/details/')) {
    refererPage = PAGE_NAME.PDP;
  } else if (prevPath?.includes('/online-pharmacy/mycart')) {
    refererPage = PAGE_NAME.MY_CART;
  } else if (prevPath === '/online-pharmacy') {
    refererPage = PAGE_NAME.EPHARMA_HOME;
  } else if (prevPath === '/doctor-consultation') {
    refererPage = PAGE_NAME.TC_HOME;
  } else if (prevPath === '/') {
    refererPage = PAGE_NAME.HOME;
  } else if (prevPath?.includes('/doctor-consultation/f/')) {
    refererPage = PAGE_NAME.FDP;
  } else if (prevPath === '/doctor-consultation/clinic-list') {
    refererPage = PAGE_NAME.FLP;
  } else if (prevPath?.includes('/doctor-consultation/s/')) {
    refererPage = PAGE_NAME.DLP;
  } else if (prevPath?.includes('/home-care/rxupload')) {
    refererPage = PAGE_NAME.RX_UPLOAD;
  } else if(prevPath?.includes('/doctor-consultation/instantgp')) {
    refererPage = PAGE_NAME.INSTANTGP;
  }
  
  return refererPage;
};

export const getPage = (path) => {
  const pageMap = [
    { pattern: "/online-pharmacy", page: PAGE.PHARMACY, exact: true, sub_type: "carousel" },
    { pattern: "/online-pharmacy/p/", page: PAGE.PDP },
    { pattern: "/online-pharmacy/c/", page: PAGE.PLP },
    { pattern: "/online-pharmacy/mycart", page: PAGE.CART },
    { pattern: "/online-pharmacy/checkout/paymentsuccess", page: PAGE.ORDER_SUCCESS },
    { pattern: "/online-pharmacy/checkout", page: PAGE.CHECKOUT },
    { pattern: "/online-pharmacy/myorders/", page: PAGE.ORDER_DETAILS },
    { pattern: "/online-pharmacy/myorders", page: PAGE.ORDER_LISTING },
    { pattern: "/online-pharmacy/lp/", page: PAGE.LANDING_PAGE, dynamicSubType: true },
    { pattern: "/online-pharmacy/spcheckout", page: PAGE.SPCHECKOUT},
    { pattern: "/online-pharmacy/searchresult", page: PAGE.SEARCHRESULT},
    { pattern: "/online-pharmacy/rxupload", page: PAGE.RXUPLOAD},
    { pattern: "/online-pharmacy/brand/", page: PAGE.BRAND},
    { pattern: "/online-pharmacy/brandlisting/", page:PAGE.BRANDLISTING},
    { pattern: "/core/login", page: PAGE.LOGIN},
    { pattern: "/settings", page: PAGE.SETTINGS},
    { pattern: "/profile/myprofile", page: PAGE.PROFILE},
  ];

  const matchedPage = pageMap.find(({ pattern, exact }) => 
    (exact ? path === pattern : path.includes(pattern))
  );

  let sub_type = null;

  if (matchedPage) {
    if (matchedPage.sub_type) {
      sub_type = matchedPage.sub_type;
    } else if (matchedPage.dynamicSubType) {
      const parts = path.split(matchedPage.pattern);
      sub_type = parts[1] ? parts[1].split('/')[0] : null;
    }
  }

  return { page: matchedPage ? matchedPage.page : PAGE.HOME, sub_type };
};

export const getRegionName = (regionName = '') => {
  switch (regionName?.toUpperCase()) {
    case 'AE':
      return 'United Arab Emirates';
    case 'SA':
      return 'Saudi Arabia';
    default:
      return 'United Arab Emirates';
  }
}
export const getCurrency = (region = '') => {
  switch (region?.toUpperCase()) {
    case 'AE':
      return 'AED';
    case 'SA':
      return 'SAR';
    default:
      return 'AED';
  }
}

export const getLanguage = (langCode = '') => {
  switch (langCode) {
    case 'ar':
      return 'Arabic Saudi Arabia';
    case 'en':
      return 'English';
    default:
      return 'English';
  }
}
